import {createSlice} from '@reduxjs/toolkit';

const initialState = {

  links: {
    data: undefined
  }
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: initialState,
  reducers: {

    tryGenerateLinks: () => {

    },
    setLinksData: (state, action) => {
      state.links.data = action.payload

    },

    reset: (state) => initialState

  }
});

export const {
  tryGenerateLinks,
  setLinksData,
  reset,


} = dashboardSlice.actions;

export default dashboardSlice.reducer;
